import { resolveAdminNamespace } from './resolve-admin-namespace.js'

export function deriveMigrationsDir(namespaceValue: string): string {
  const namespace = resolveAdminNamespace(namespaceValue)
  return `./${namespace.segment}/lib/db/migrations`
}
